import Splitting from "splitting";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export class W3FadeInText {
  constructor() {
    if (!document.querySelector(".w3-fade-in-text")) return;

    this.start();
  }

  start(): void {
    gsap.registerPlugin(ScrollTrigger);
    Splitting();
    const fadeInTexts = [
      ...document.querySelectorAll(
        ".w3-fade-in-text[data-splitting][data-fadeInEffect]",
      ),
    ];
    const scroll = () => {
      fadeInTexts.forEach((text) => {
        gsap.fromTo(
          text.querySelectorAll(".word"),
          {
            "will-change": "opacity",
            opacity: 0.1,
          },
          {
            ease: "none",
            opacity: 1,
            stagger: 0.05,
            scrollTrigger: {
              trigger: text,
              start: "top bottom-=20%",
              end: "center top+=20%",
              scrub: true,
            },
          },
        );
      });
    };
    scroll();
  }
}
